<template>
  <b-container fluid class="text-dark">
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                  <template v-slot:body>
                      <b-overlay :show="unitLoad">
                        <b-row>
                            <b-col lg="12" sm="12">
                            {{tmpData}}
                          </b-col>
                        </b-row>
                      </b-overlay>
                  </template>
                </iq-card>
            </b-col>
        </b-row>
  </b-container>
</template>
<script>
export default {
  components: {
  },
  created () {
    if (this.$route.query.id) {
       this.tmpData = this.$store.state.list.find(item => item.id === parseInt(this.$route.query.id))
    }
  },
  data () {
    return {
      tmpData: []
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
